import { SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountQueryKey } from "../../account/account.keys";
import { bondRequestPreviewsQueryKey, bondRequestsQueryKey } from "../bond-request.keys";
import { redirectToIssuedBond } from "../utils";

export const useReopenBondRequest = (quoteId: SuretyQuoteId, suretyAccountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { post } = useRequest();

	const mutation = useMutation({
		meta: { redirectOnError: redirectToIssuedBond },
		mutationFn: async () =>
			await post(`/v2/surety/accounts/${suretyAccountId}/quotes/${quoteId}/open`, {}, "none"),
		onSuccess: () => {
			void queryClient.invalidateQueries({ queryKey: accountQueryKey(suretyAccountId) });
			void queryClient.invalidateQueries({ queryKey: bondRequestsQueryKey(quoteId) });
			void queryClient.invalidateQueries({ queryKey: bondRequestPreviewsQueryKey() });
		},
	});

	return {
		reopenBondRequest: mutation.mutate,
		reopenBondRequestLoading: mutation.isPending,
		reopenBondRequestError: mutation.error,
		dismissReopenBondRequestError: () => {
			mutation.reset();
		},
	};
};
